import type { Resource } from '../../';
export const product_details_artlabs_tryOn: Resource = {"default":"Try-on"};
